<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible"
               v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑仓库信息
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="仓库名称" required>
                    <el-input v-model="form.warehouseName" placeholder="请输入物仓库名称"></el-input>
                </el-form-item>
                <el-form-item label="仓号" required>
                    <el-input v-model="form.warehouseNo" placeholder="请输入仓号"></el-input>
                </el-form-item>
                <el-form-item label="使用部门">
                    <selectTree style="width:200px" v-model="tree_model" :rowKeys="treekeys" :tree-data="treeData" :isMulti="false"
                                placeholder="请选择使用部门"></selectTree>
                </el-form-item>
                <el-form-item label="仓库类别">
                    <el-select v-model="form.warehouseType" placeholder="请选择仓库类别" style="width: 100%">
                        <el-option label="工程物资仓" value="工程物资仓"></el-option>
                        <el-option label="运行客服物资仓库" value="运行客服物资仓库"></el-option>
                        <el-option label="维抢修物资仓库" value="维抢修物资仓库"></el-option>
                        <el-option label="甲供仓库" value="甲供仓库"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库负责人">
                    <el-input v-model="form.warehouseMan" placeholder="请输入仓号"></el-input>
                </el-form-item>
                <el-form-item label="仓库地址" class="bzClass">
                    <el-input
                            resize="none"
                            type="textarea"
                            placeholder="请输入仓库地址"
                            v-model="form.warehouseAddress"
                            rows="2"
                            show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="备注" class="bzClass">
                    <el-input
                            resize="none"
                            type="textarea"
                            placeholder="请输入备注"
                            v-model="form.remark"
                            rows="2"
                            show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import selectTree from '@/components/tools/tree/selectTree'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selectTree},
        data() {
            return {
                tree_model: {
                    id: this.formData.p_id,
                    name: this.formData.p_name
                },
                treeData: [],
                treekeys: {
                    id: 'id',
                    name: 'name',
                    parent: 'parentId',
                    children: 'children'
                },
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
            };
        },
        mounted() {
            this.getFolder();
            this.tree_model = {
              id: this.formData.departmentId,
              name: this.formData.departmentName
            }
        },
        methods: {
            async getFolder() {
                this.dialoading = true;
                let param = {
                    url:"/department/selZTree",
                    param:{}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.treeData = data.data.jsonStr;
                }
                this.dialoading = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                this.form.departmentId = this.tree_model.id;
                this.form.departmentName = this.tree_model.name;

                if(this.$pub.isEmpty(this.form.warehouseName)){
                    this.$message({message: '请输入仓库名称', type: 'error'});
                    return false;
                }

                if(this.$pub.isEmpty(this.form.warehouseNo)){
                    this.$message({message: '请输入仓号', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
        }
    }
</script>
